import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * KHR_materials_variants specification allows duplicated variant names
 * but it makes handling the extension complex.
 * We ensure tha names and make it easier.
 * If you want to export the extension with the original names
 * you are recommended to write GLTFExporter plugin to restore the names.
 *
 * @param variantNames {Array<string>}
 * @return {Array<string>}
 */
var ensureUniqueNames = function ensureUniqueNames(variantNames) {
  var uniqueNames = [];
  var knownNames = new Set();
  var _iterator = _createForOfIteratorHelper(variantNames),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var name = _step.value;
      var uniqueName = name;
      var suffix = 0;
      // @TODO: An easy solution.
      //        O(N^2) in the worst scenario where N is variantNames.length.
      //        Fix me if needed.
      while (knownNames.has(uniqueName)) {
        uniqueName = name + '.' + ++suffix;
      }
      knownNames.add(uniqueName);
      uniqueNames.push(uniqueName);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return uniqueNames;
};
/**
 * Convert mappings array to table object to make handling the extension easier.
 *
 * @param
 *     extensionDef {glTF.meshes[n].primitive.extensions.KHR_materials_variants}
 * @param variantNames {Array<string>} Required to be unique names
 * @return {Map}
 */
var mappingsArrayToTable = function mappingsArrayToTable(extensionDef) {
  var table = new Map();
  var _iterator2 = _createForOfIteratorHelper(extensionDef.mappings),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var mapping = _step2.value;
      var _iterator3 = _createForOfIteratorHelper(mapping.variants),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var variant = _step3.value;
          table.set(variant, {
            material: null,
            gltfMaterialIndex: mapping.material
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return table;
};
var GLTFMaterialsVariantsExtension = /*#__PURE__*/function () {
  function GLTFMaterialsVariantsExtension(parser) {
    _classCallCheck(this, GLTFMaterialsVariantsExtension);
    this.parser = parser;
    this.name = 'KHR_materials_variants';
  }
  // Note that the following properties will be overridden even if they are
  // pre-defined
  // - gltf.userData.variants
  // - mesh.userData.variantMaterials
  _createClass(GLTFMaterialsVariantsExtension, [{
    key: "afterRoot",
    value: function afterRoot(gltf) {
      var _this = this;
      var parser = this.parser;
      var json = parser.json;
      if (json.extensions === undefined || json.extensions[this.name] === undefined) {
        return null;
      }
      var extensionDef = json.extensions[this.name];
      var variantsDef = extensionDef.variants || [];
      var variants = ensureUniqueNames(variantsDef.map(function (v) {
        return v.name;
      }));
      var _iterator4 = _createForOfIteratorHelper(gltf.scenes),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var scene = _step4.value;
          // Save the variants data under associated mesh.userData
          scene.traverse(function (object) {
            var mesh = object;
            if (!mesh.material) {
              return;
            }
            var association = parser.associations.get(mesh);
            if (association == null || association.meshes == null || association.primitives == null) {
              return;
            }
            var meshDef = json.meshes[association.meshes];
            var primitivesDef = meshDef.primitives;
            var primitiveDef = primitivesDef[association.primitives];
            var extensionsDef = primitiveDef.extensions;
            if (!extensionsDef || !extensionsDef[_this.name]) {
              return;
            }
            mesh.userData.variantMaterials = mappingsArrayToTable(extensionsDef[_this.name]);
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      gltf.userData.variants = variants;
      return Promise.resolve();
    }
  }]);
  return GLTFMaterialsVariantsExtension;
}();
export { GLTFMaterialsVariantsExtension as default };